// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__32iTY","footer":"ModalInfo_footer__1BIvt"};